import React from 'react'
import { Menu, MenuItem, MenuItemStyles } from 'react-pro-sidebar'
import { useCookies } from 'react-cookie'

const ENTERPRISE_DASHBOARD_APP_URL = import.meta.env.REACT_APP_ENTERPRISE_DASHBOARD_APP_URL!
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export interface EnterpriseDashboardMenuProps {
  menuItemStyles: MenuItemStyles
}

export const EnterpriseDashboardMenu: React.FC<EnterpriseDashboardMenuProps> = ({ menuItemStyles }) => {
  const [, setCookie] = useCookies()

  const handleAppSwitch = () => {
    setCookie('preferredAppVersion', 'enterprise-dashboard', { path: '/', maxAge: COOKIE_MAX_AGE })
    window.location.href = ENTERPRISE_DASHBOARD_APP_URL
  }

  return (
    <Menu menuItemStyles={menuItemStyles} className='zocks-menu'>
      <MenuItem icon={<i className='bi bi-diagram-3' />} onClick={handleAppSwitch}>
        <div className='button-small'>Enterprise Admin</div>
      </MenuItem>
    </Menu>
  )
}
